import { JobTitle } from "domain/entities/job-title";
import {
  useCreateJobTitleMutation,
  useUpdateJobTitleMutation,
} from "presentation/hooks/use-query-job-title";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import "./index.css";

interface JobTitleFormProps {
  visible: boolean;
  onHide: () => void;
  jobTitle?: JobTitle;
}

const JobTitleForm: React.FC<JobTitleFormProps> = ({
  visible,
  onHide,
  jobTitle,
}) => {
  const toast = useRef<Toast>(null);
  const [formData, setFormData] = useState<JobTitle>();

  const { mutate: createJobTitle, isPending: isCreating } =
    useCreateJobTitleMutation();
  const { mutate: updateJobTitle, isPending: isUpdating } =
    useUpdateJobTitleMutation();

  useEffect(() => {
    setFormData(jobTitle);
  }, [jobTitle]);

  const handleSave = () => {
    if (!formData || !formData.name) {
      toast.current?.show({
        severity: "warn",
        summary: "Aviso",
        detail: "O nome do cargo é obrigatório.",
        life: 3000,
      });
      return;
    }

    const mutationOptions = {
      onSuccess: () => {
        toast.current?.show({
          severity: "success",
          summary: "Sucesso",
          detail: `Cargo ${formData.id ? "atualizado" : "criado"} com sucesso.`,
          life: 3000,
        });
        onHide();
      },
      onError: (error: any) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail:
            error.response?.data?.message ||
            "Ocorreu um erro ao guardar o cargo.",
          life: 3000,
        });
      },
    };

    if (formData.id) {
      updateJobTitle(formData, mutationOptions);
    } else {
      createJobTitle(formData, mutationOptions);
    }
  };

  const footer = (
    <div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        onClick={handleSave}
        loading={isCreating || isUpdating}
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header="Cargo"
        visible={visible}
        onHide={onHide}
        footer={footer}
        style={{ width: "30vw" }}
        modal
      >
        <div className="p-fluid formgrid grid">
          <div className="field col-8">
            <label htmlFor="name">Nome</label>
            <InputText
              id="name"
              value={formData?.name || ""}
              onChange={(e) =>
                setFormData(
                  (prev) => ({ ...prev, name: e.target.value } as JobTitle)
                )
              }
            />
          </div>
          <div className="field col-4">
            <label htmlFor="isPeopleManager">People Manager</label>
            <InputSwitch
              id="isPeopleManager"
              checked={formData?.isPeopleManager || false}
              onChange={(e) =>
                setFormData(
                  (prev) => ({ ...prev, isPeopleManager: e.value } as JobTitle)
                )
              }
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default JobTitleForm;
